

const getDeliveryFees = (storeData, pickupGeopoint, targetGeopoint)=>{
 
  //console.log('getDeliveryPrice: ',storeData);

  const normal = storeData.normalRates; 
  const extended = storeData.extendedRates;
 
  if(!normal.hasRates)
         return {status:"disable"}; 

  if(!pickupGeopoint)
        return {status:"disable"}; 

  if(!storeData.activeRates)
      return {status:"disable"}; 
  
  if(!targetGeopoint)
      return {
        status:"missing",
        normalPrice: normal.price,
        normalRadius: normal.radius,
      }; 

  const distance = getDistance(targetGeopoint,pickupGeopoint); 
 
  if(distance<= normal.radius){
      return {
        status:"ok", 
        distance:distance,
        normalPrice: normal.price,
        normalRadius: normal.radius,
      }
  }

  if(!extended.hasRates){
    return {
      status:"out",
      distance:distance,
      normalPrice: normal.price,
      normalRadius: normal.radius,
    }; 
  }

  const extraDistance = distance -normal.radius;
  
  if(distance <= extended.maxRadius){
    return {
      status:"ok", 
      distance:distance,
      normalPrice: normal.price,
      normalRadius: normal.radius,

      extraDistance: extraDistance,
      extraPrice:   extraDistance*extended.priceByKm,
      extraByKm:    extended.priceByKm,
      extraRadius:  extended.maxRadius,
      
    }
  }

  return {
    distance:distance,
    status:"out",
    maximun: extended.maxRadius,
  }; 

}

  const rad = (x) => {
    return x * Math.PI / 180;
  };
  
  const getDistance = (p1, p2) => {
    const R = 6378137; // Earth’s mean radius in meter
    const dLat = rad(p2.latitude - p1.latitude);
    const dLong = rad(p2.longitude - p1.longitude);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1.latitude)) * Math.cos(rad(p2.latitude)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d/1000; // returns the distance in meter
  };



export {
   getDeliveryFees, 
   getDistance,
  }; 